import React from "react";

import LocationIndicator from "components/sub-components/LocationIndicator/LocationIndicator";
import PageContainerComponent from "../../../../../../components/common/page-container-component/PageContainerComponent";
import styles from "./PaymentPage.module.css";
import FloorPlateNavOptions from "components/common/floor-plate-nav-options/FloorPlateNavOptions";
import { Box, Divider } from "@chakra-ui/react";
function PaymentPage() {
  const labels_Values = [
    { label: "Type", value: "Garden" },
    { label: "View", value: "Street" },
    { label: "Area", value: "139" },
    { label: "Garden", value: "31" },
    { label: "Total Area", value: "170" },
    { label: "Cash Price + Parking + Storage", value: "2,496,259" },
    { label: "Maintenance", value: "356,965" },
    { label: "Club House", value: "125,000" },
    { label: "Installment 7 years", value: "3,569,650" },
    { label: "Installment 15% Deposit", value: "535,448" },
    { label: "Installment 7 years", value: "433,458" },
    { label: "Installment Parking", value: "150,000" },
    { label: "Installment Warehouse", value: "86,000" },
    { label: "Status", value: "Available" },
    { label: "Finishing", value: "Core & Shell" },
    { label: "Delivery", value: "Ready To Go" },
  ];
  return (
    <PageContainerComponent>
      <LocationIndicator text="Zone 6 - Type D" fontSize={60} />
      <div className={styles.paymentContainer}>
        {labels_Values.map((item, index) => (
          <>
            <Box className={styles.paymentColumn} key={index}>
              <Box
                as="p"
                className={styles.paymentColumnLabel}
                fontSize={{
                  tablet7: "1.6rem",
                  tablet16: "3rem",
                }}
              >
                {item.label}
              </Box>
              <Box
                as="p"
                className={styles.paymentColumnValue}
                fontSize={{
                  tablet7: "1.6rem",
                  tablet16: "3rem",
                }}
              >
                {item.value}
              </Box>
            </Box>
            <Divider color="brown" />
          </>
        ))}
      </div>
      <FloorPlateNavOptions isPaymentPage />
    </PageContainerComponent>
  );
}

export default PaymentPage;
